// ponytail: client-side filter on /collections — fine for < few hundred cards
(function () {
  const root = document.querySelector('[data-d1-lc]');
  if (!root) return;

  const search = root.querySelector('[data-d1-lc-search]');
  const chips = root.querySelectorAll('[data-d1-lc-chip]');
  const items = root.querySelectorAll('[data-d1-lc-item]');
  const meta = root.querySelector('[data-d1-lc-meta]');
  const empty = root.querySelector('[data-d1-lc-empty]');
  const total = items.length;

  let activeFilter = 'all';

  function apply() {
    const q = (search?.value || '').trim().toLowerCase();
    let visible = 0;

    items.forEach((item) => {
      const title = item.getAttribute('data-title') || '';
      const cat = item.getAttribute('data-category') || 'products';
      const matchFilter = activeFilter === 'all' || cat === activeFilter;
      const matchSearch = !q || title.includes(q);
      const show = matchFilter && matchSearch;
      item.hidden = !show;
      if (show) visible += 1;
    });

    if (meta) {
      meta.textContent =
        visible === total
          ? `${visible} categories`
          : `${visible} of ${total} categories`;
    }

    if (empty) empty.classList.toggle('is-visible', visible === 0);
  }

  chips.forEach((chip) => {
    chip.addEventListener('click', () => {
      activeFilter = chip.getAttribute('data-d1-lc-chip') || 'all';
      chips.forEach((c) => {
        c.setAttribute('aria-pressed', c === chip ? 'true' : 'false');
      });
      apply();
    });
  });

  search?.addEventListener('input', apply);
  apply();
})();
